import React, { useMemo, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FirstNameLastName, Input, LocationCoordinates, Message, SubmitResetClearButton, Timezone, Title } from './ClientUtil';
import { validateAddress, validateCity, validateDouble, validateName } from './ClientValidate';
import { axiosErrorHandler, axiosGetWithHeader, axiosPostWithHeader, axiosResponseHandler, ShowAlertError } from '../Common/axios';
import Spinner from 'react-bootstrap/esm/Spinner';
import { handleInput, handleReset } from '../Common/Util';
import { SingleButton } from '../Login/LoginUtil';

export function EditProfile (props) {
  const [data, setData] = useState([]);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [address, setAddress] = useState('');
  const [timezone, setTimezone] = useState('');
  const [city, setCity] = useState('');
  const [latitude, setLatitude] = useState('');
  const [longitude, setLongitude] = useState('');
  const [message, setMessage] = useState('');
  const [success, setSuccess] = useState(false);
  const setMethod = { 
    setFirstName, setLastName, setAddress, setTimezone, setCity, setLatitude, setLongitude, setMessage };

  const firstNameReference = useRef();
  const lastNameReference = useRef();
  const addressReference = useRef();
  const timezoneReference = useRef();
  const cityReference = useRef();
  const latitudeReference = useRef();
  const longitudeReference = useRef();
  const [errorAlert, setErrorAlert] = useState(null);
  const [spinner, setSpinner] = useState('Loading - Change Personal Details Page');
  const navigate = useNavigate();

  function init() {
    axiosGetWithHeader("/astrologer/view",
      (response)=>{
        setData(response.data);
        assignDbData(response.data);
        setSpinner(null);
      },
      (error)=>{
        console.log(error);
        setSpinner(null);
        setErrorAlert(error.message);
      }
    );
  }

  useMemo(() => {
    axiosGetWithHeader("/astrologer/view",
      (response)=>{
        setData(response.data);
        assignDbData(response.data);
        setSpinner(null);
      },
      (error)=>{
        console.log(error);
        setSpinner(null);
        setErrorAlert(error.message);
      }
    );
  }, []);

  function assignDbData(data){
    setFirstName(data.firstName);
    setLastName(data.lastName);
    setAddress(data.address===null||data.address===undefined?"":data.address);
    setTimezone((data.timezone===null||data.timezone===undefined)?"5.5":data.timezone);
    setCity(data.city===null||data.city===undefined?"":data.city);
    setLatitude(data.latitude===null||data.latitude===undefined?"":data.latitude);
    setLongitude(data.longitude===null||data.longitude===undefined?"":data.longitude);
  }

  const handleBack = (event) => {
    setTimeout(() => {
      navigate('/profile.html', { replace: true });
    }, 100);
  }

  const handleLocationInput = (name, value) => {
    switch(name) {
      case 'latitude': setLatitude(value); break;
      case 'longitude': setLongitude(value); break;
      default : 
    }
  }

  const handleSubmit = (event) => {
    var msg = '';
    if(msg==='') msg = validateName(event, firstNameReference,firstName,
      lastNameReference, lastName);
    if(msg==='' && address.trim()!=="") msg = validateAddress(event,addressReference,address);
    if(msg==='') {
      if( (city!==null && city.trim()!=="") ||
          (longitude!==null && longitude.trim()!=="")||
          (latitude!=null && latitude.trim()!=="")) {
        if(msg==='') msg = validateCity(event,"city",cityReference,city);
        if(msg==='') msg = validateDouble(event,"latitude",latitudeReference,latitude,-90,90);
        if(msg==='') msg = validateDouble(event,"longitude",longitudeReference,longitude,-180,180);
      } 
    }
    setMessage(msg);

    if(msg==='') {
      const data = {
        firstName: firstName,
        lastName: lastName,
        address: address,
        timezone: timezone,
        city: city,
        longitude: longitude,
        latitude: latitude
      }
      axiosPostWithHeader("/astrologer/edit", data,
        (response)=>{
            setMessage(axiosResponseHandler(response, firstNameReference, ()=>customhandleReset(setMethod,firstNameReference), "Your personal details are updated successfully"));
            init();
            if(response.data.code==='200') {
              setSuccess(true);
            }
        },
        (error)=>{
          setMessage(axiosErrorHandler(firstNameReference,error));
          setErrorAlert(error.message);
      }
      );
    }
      
    event.preventDefault();
  }

  const customhandleReset = (setMethod,ref) =>{
      handleReset(setMethod,ref);
      setTimezone('5.5');
  }  

  const handleDBDataReset =  (event) => {
    assignDbData(data);
    setMessage("");
    firstNameReference.current.focus();
}

  return(
    <>
        {spinner===null?<></>:<>{spinner} <Spinner animation="border" size="sm" /></>}
        <div class="m-0 p-0 row align-items-top">
        <div class="col-sm-2 col-md-2 d-none d-md-block"></div>    
        <div class="col-sm-12 col-md-8 m-0 p-2 bg-white text-black">
          <Title title="Change Personal Details" urlcallback={handleBack}></Title>
          <div class="row m-0 p-0 w-100 border rounded">
            <div class="col m-0 p-0 justify-content-center">
              <div class="row m-0 p-0 w-100">
              <div class="col-3 d-none d-lg-block"></div>
              <div class="col-sm-12 col-lg-6">
                <Message msg={message} /> 
                {success===false?
                <form method="post" onSubmit={handleSubmit}>
                  <FirstNameLastName title="Name *" firstnamereference={firstNameReference} lastnamereference={lastNameReference} firstvalue={firstName} lastvalue={lastName} callback={(event)=>handleInput(event,setMethod)} />
                  <Input name="address" title="Address" placeholder="Address (optional)" reference={addressReference} data={address} callback={(event)=>handleInput(event,setMethod)} />
                  <Timezone name="timezone" reference={timezoneReference} data={timezone} callback={(event)=>handleInput(event,setMethod)} />
                  <LocationCoordinates 
                        cityname="city" citytitle="City" cityreference={cityReference} cityvalue={city}
                        coordinatesname="location" coordinatestitle="Location (Latitude, Longitude)" 
                        longitudename="longitude" latitudename="latitude" 
                        longitudereference={longitudeReference} latitudereference={latitudeReference} 
                        longitudevalue={longitude} latitudevalue={latitude} 
                        callback={(event)=>handleInput(event,setMethod)}  callbacklocation={handleLocationInput} />
                  <SubmitResetClearButton callback={()=>customhandleReset(setMethod,firstNameReference)} callbackReset={handleDBDataReset} /> 
                </form>
                : <SingleButton title="Ok" callback={handleBack}/>
                }
              </div>  
              <div class="col-3 d-none d-lg-block"></div>
              </div>

            </div>
          </div>
        </div>
        <div class="col-sm-2 col-md-2 d-none d-md-block"></div>    
        <ShowAlertError errorAlert={errorAlert} setErrorAlert={setErrorAlert}/>
      </div>
    </>
  );
}
